import React from 'react'
import { Link } from 'gatsby'
import Button from '../Button/Button'
import * as styles from './styles'

export default function ReadyToStartBanner() {
  return (
    <styles.Container>
      <styles.Header>Ready to start?</styles.Header>
      <styles.ButtonContainer>
        <Link to="/request-trial">
          <Button size="small">
            Request free trial
          </Button>
        </Link>
      </styles.ButtonContainer>
    </styles.Container>
  )
}
